// Build the breadcrumb trail shown above the simulation dashboards
// (Summary / Verification / etc). Kept as a pure function so the same
// data drives both pages and they don't drift apart over time.
//
// Inputs are read by the caller from session storage so this helper
// can be unit-tested without touching globals.

export const stripCustomerPrefix = (microgridDesign, customerPrefix) => {
  if (!microgridDesign) return "";
  if (customerPrefix && microgridDesign.startsWith(`${customerPrefix}-`)) {
    return microgridDesign.slice(customerPrefix.length + 1);
  }
  return microgridDesign;
};

const extractReadableSimName = (fileName) => {
  if (!fileName) return "";
  const match = fileName.match(/\d{4}-\d{2}-\d{2}_[^.]+(?=\.csv)/);
  return match ? match[0].replace("timeseries-", "") : fileName;
};

export const buildSimulationCrumbs = ({
  jobTitle,
  customerFirstName,
  customerPrefix,
  microgridDesign,
  fileName,
}) => {
  const stripped = stripCustomerPrefix(microgridDesign, customerPrefix);
  const microgridLabel = stripped ? `${stripped}-Simulations` : "Simulations";
  const readableSimName = extractReadableSimName(fileName);

  const microgridCrumb = {
    label: microgridLabel,
    path: "/microgrid/meter/simulations",
  };
  const customerCrumb = {
    label: customerFirstName || "",
    path: "/microgrid-page-design",
  };
  const finalCrumb = { label: readableSimName };

  if (jobTitle === "Customer") {
    return [customerCrumb, microgridCrumb, finalCrumb];
  }

  if (jobTitle === "Employee") {
    return [
      { label: "Customer List", path: "/employeehomepage" },
      customerCrumb,
      microgridCrumb,
      finalCrumb,
    ];
  }

  return [
    {
      label: "Customer List",
      path: "/employees",
      state: { activeTab: "customers" },
    },
    customerCrumb,
    microgridCrumb,
    finalCrumb,
  ];
};
